import { render, staticRenderFns } from "./historial_reembolsos.vue?vue&type=template&id=47a733d3"
import script from "./historial_reembolsos.vue?vue&type=script&lang=js"
export * from "./historial_reembolsos.vue?vue&type=script&lang=js"
import style0 from "./historial_reembolsos.vue?vue&type=style&index=0&id=47a733d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports